<template>
  <div id="app">
    <header class="cabecalho-sistema cabecalho-sistema_fixo">
      <div class="cabecalho-sistema__container-primario">
        <button class="botao-hamburguer" aria-label="Menu principal">
          <span class="botao-hamburguer__linha-1"></span>
          <span class="botao-hamburguer__linha-2"></span>
          <span class="botao-hamburguer__linha-3"></span>
        </button>
        <a href="/">
          <img
            class="cabecalho-sistema__logo"
            src="../../assets/imagens/logo-habix.svg"
            alt="Logo do sistema"
          />
        </a>
      </div>
      <div class="cabecalho-sistema__container-secundario">
        <nav class="cabecalho-sistema__menu">
          <ul class="cabecalho-sistema__lista-de-itens">
            <li id="botao-abrir-suporte-online">
              <a
                class="cabecalho-sistema__item-de-menu"
                href="https://somosdigix.movidesk.com/form/5822/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i
                  class="fal fa-question-circle fa-lg u-margem-direita-mini"
                  aria-hidden="true"
                ></i>
                Suporte
              </a>
            </li>
            <li class="dropdown dropdown_direita">
              <button
                class="cabecalho-sistema__item-de-menu"
                aria-label="Opções para o usuário Administrador"
                aria-haspopup="true"
              >
                <span class="cabecalho-sistema__icone-do-usuario">
                  <i class="far fa-user"></i>
                </span>
                <span class="cabecalho-sistema__nome-do-usuario">{{
                  usuarioLogado()
                }}</span>
                <i class="far fa-angle-down u-margem-esquerda-pequena"></i>
              </button>
              <ul class="dropdown__lista" aria-label="Submenu">
                <li class="dropdown__item">
                  <a :href="politicaPrivacidadeUrl"
                    target="_blank" class="dropdown__link">
                    <i class="far fa-lock dropdown__icone" aria-hidden="true"></i>
                    Política de privacidade
                  </a>
                </li>
                <li class="dropdown__item">
                  <a :href="termoDeUsoUrl" target="_blank"
                    class="dropdown__link">
                    <i class="far fa-file-check dropdown__icone" aria-hidden="true"></i>
                    Termo de uso
                  </a>
                </li>
                <li class="dropdown__item">
                  <a
                    class="dropdown__link"
                    :href="alterarSenhaUrl"
                  >
                    <i class="far fa-exchange dropdown__icone"></i>
                    Alterar senha
                  </a>
                </li>
                <li class="dropdown__item">
                  <a @click="logout()" class="dropdown__link" href="#">
                    <i class="far fa-sign-out dropdown__icone"></i>
                    Sair
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </header>

    <nav
      class="menu-lateral menu-lateral_fixo menu-lateral_minimizado no-print"
    >
      <menu class="menu menu-lateral__lista">
        <menuitem
          v-for="menu in menus"
          class="menu-lateral__item"
          :key="menu.id"
          @click="ativarMenu(menu.id)"
        >
          <router-link
            :to="{ name: menu.link }"
            v-if="usuarioPossuiAlgumaPermissao(menu.permissoes)"
            :title="menu.descricao"
            :class="menuAtivo === menu.id ? 'menu-lateral__link_ativo' : ''"
            class="menu-lateral__link"
          >
            <i
              :class="menu.icone"
              class="menu-lateral__icone"
              aria-hidden="true"
            ></i>
            <span class="menu-lateral__texto">{{ menu.descricao }}</span>
          </router-link>
        </menuitem>
      </menu>
    </nav>
    <div class="pagina__conteudo-container">
      <main class="pagina__conteudo-principal">
        <header class="barra-navegacao no-print">
          <div class="barra-navegacao__container">
            <div class="barra-navegacao__conteudo-primario">
              <a
                v-if="!$route.meta.ocultarBotaoVoltar"
                @click="goBack()"
                href="#"
                class="barra-navegacao__botao-voltar"
                aria-label="Voltar"
              >
                <i class="fal fa-arrow-left" aria-hidden="true"></i>
              </a>
              <div
                class="barra-navegacao__container-titulos sub-menu-categoria"
              >
                <ul class="barra-navegacao__rastro"></ul>
                <cabecalho-do-conteudo class="barra-navegacao__titulo" />
                <h1 id="titulo-da-pagina" class="barra-navegacao__titulo"></h1>
              </div>
            </div>
          </div>
        </header>
        <div>
          <router-view></router-view>
        </div>
      </main>
    </div>
    <div class="sobreposicao"></div>
  </div>
</template>

<script>
import VueJwtDecode from "vue-jwt-decode";
import iniciarGerenciadorDeMenu from "../../utils/botao-hamburguer";
import menus from "../../utils/menuDoSistema";
import CabecalhoDoConteudo from "../shared/CabecalhoDoConteudo";
import ExpandirConteudo from "../shared/ExpandirConteudo";
import Modal from "../shared/Modal";

export default {
  name: "app",
  data() {
    return {
      menuAtivo: "",
      politicaPrivacidadeUrl: process.env.VUE_APP_URL_POLITICA_DE_PRIVACIDADE,
      termoDeUsoUrl: process.env.VUE_APP_URL_TERMO_DE_USO,
      alterarSenhaUrl: process.env.URL_API_SEGURANCA + "/Seguranca/AlterarSenha",
      menus,
    };
  },
  created() {
    const menuPelaRota = this.menus.find((m) => m.link === this.$route.name);
    if (menuPelaRota) this.menuAtivo = menuPelaRota.id;

    window.onload = function () {
      iniciarGerenciadorDeMenu();
    };

    this.gerenciarExibicaoDePesquisaDoNps();
  },
  watch: {
    $route() {
      this.gerenciarExibicaoDePesquisaDoNps();
    },
  },
  methods: {
    usuarioLogado() {
      return this.$usuario.obterUsuarioLogado().login || "";
    },
    logout() {
      this.$usuario.deslogar();
      this.redirecionarParaLogOffExterno();
    },
    redirecionarParaLogOffExterno() {
      const returnUrl = window.location.origin + window.location.pathname;
      const urlLogoffExternoSeguranca = `${process.env.URL_API_SEGURANCA}/Seguranca/LogOffExterno?ReturnUrl=${encodeURIComponent(returnUrl)}`;
      
      window.location.href = urlLogoffExternoSeguranca;
    },
    usuarioPossuiAlgumaPermissao(permissoes) {
      return permissoes.some((permissao) =>
        this.$usuario.possuiPermissao(permissao)
      );
    },
    goBack() {
      window.history.back();
    },
    ativarMenu(menu) {
      this.menuAtivo = menu;
    },
    gerenciarExibicaoDePesquisaDoNps() {
      if (process.env.NODE_ENV === "dev") return;

      let usuario = this.$usuario.obterUsuarioLogado();
      let tokenDeAutorizacaoDoKeycloak = usuario.tokenDeAutorizacaoDoKeycloak;
      let tokenDecodificado = VueJwtDecode.decode(tokenDeAutorizacaoDoKeycloak);
      
      let nomeDoUsuarioLogado = tokenDecodificado["name"];
      let emailDoUsuarioLogado = tokenDecodificado["email"];

      configurarScriptDoIndecx(nomeDoUsuarioLogado, emailDoUsuarioLogado);
    },
  },
  components: { CabecalhoDoConteudo, ExpandirConteudo, Modal },
};

function configurarScriptDoIndecx(nomeDoUsuarioLogado, emailDoUsuarioLogado) {
  window.nome = nomeDoUsuarioLogado;
  window.email = emailDoUsuarioLogado;
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", "GTM-WX7DMDF4");
}
</script>



// WEBPACK FOOTER //
// Layout.vue?3fb04d2a